import { SlideGallery } from "@/features/work/SlideGallery";

const businessEcosystems = [
  {
    src: "/images/ecosystem-pre-pivot/hero.png",
    caption: "AI 2016 Ecosystem",
    width: 1429,
    height: 800,
    alt: "ecosystem.Ai workbench, AI 2016 Ecosystem, on the Graph Investors view. An investor network with Affectiva selected. Affectiva is described as an MIT Media Lab spin-off whose Emotion AI organizes how people and technology interact. Navigation includes Dashboard, Challenges, Ecosystems, and Ideas, plus graph views for people, past teams, locations, board members, market, investors, and boards.",
  },
  {
    src: "/images/ecosystem-pre-pivot/network.png",
    caption: "Network",
    width: 788,
    height: 538,
    alt: "Investor and company network. Highlighted nodes are BISON, ForwardLane Inc, Aire, and Sway Finance. Connected names include Telegraph Hill Capital, Right Side Capital Management, SOSV, ZenStone Venture Capital, Techstars, Partnership Fund for New York City, Sunstone Capital, Accion, SparkLabs Global Ventures, White Star Capital, and Y Combinator.",
  },
  {
    src: "/images/ecosystem-pre-pivot/company-timeline.png",
    caption: "Company timeline",
    width: 1424,
    height: 801,
    alt: "AI 2016 Ecosystem overview. The file is AI-2016-1, 451 items, generated by jayvanzyl on 9 October 2016. A company timeline runs from 1990 to 2015, with funding amounts on companies including iRobot, Kurzweil Technologies, AI Metrix, Silver Egg Technology, ULIXE Group, and Data Quarks Limited.",
  },
  {
    src: "/images/ecosystem-pre-pivot/timeline.png",
    caption: "Timeline",
    width: 870,
    height: 523,
    alt: "Closer company timeline from 2013 to 2016. Companies and funding include Singular Intelligence, Aire at $7,000,000, InvestGlass at $100,000, Behavox at $1,400,000, Walnut Algorithms at $446,332, EDGARReader.Com at $25,000, Olivia AI at $500,000, Trim at $2,200,000, and Sway Finance at $120,000.",
  },
] as const;

const predictionServer = [
  {
    src: "/images/ecosystem-pre-pivot/prediction-e3.png",
    caption: "Prediction wizard",
    width: 3218,
    height: 1620,
    alt: "Prediction wizard, step 1 of 4, Algorithm. Model algorithm menu lists Deep Learning, Distributed Random Forest, Gradient Boosted Machine, Generalized Linear Modeling, Naive Bayes, XGBoost, K-Means, and Word2Vec. Later steps are Data Source, Model Setup, and Conclude.",
  },
  {
    src: "/images/ecosystem-pre-pivot/prediction-e2.png",
    caption: "Transaction analysis project",
    width: 3198,
    height: 1730,
    alt: "Transaction analysis project wizard. Five steps: Project Information, Munging Steps, Munging Data Settings, Munging Properties, and Prediction Preparation. Fields are Project ID, Description, Project Type (Automation or Analytics), Project Purpose, and project start and end dates.",
  },
  {
    src: "/images/ecosystem-pre-pivot/prediction-e1.png",
    caption: "Server API",
    width: 3174,
    height: 1538,
    alt: "ecosystem.Ai Server API documentation, Apache 2.0, for the ecosystemAi engine and prediction engine. Visible operations include DELETE /deleteModel, /deletePrediction, and /deletePredictionProject; GET /getModel, /getPrediction, /getPredictionProject, /getPredictionProjects, and /getUserPredictions; POST /saveModel, /savePrediction, and /savePredictionProject.",
  },
] as const;

const architecture = [
  {
    src: "/images/ecosystem-pre-pivot/product-architecture.png",
    caption: "Product architecture",
    width: 970,
    height: 858,
    alt: "Product architecture. Top band eAi Stacked Ensembles holds Client Pulse Responder, Ecogenetic, and a block labeled Commemity, covering transaction enrichment, spending energy, segmentation, centralities of behavior, financial wellbeing, and behavior shift. Below are the ecosystem.Ai Server (workbench, test data, eAi Tools API, MongoDB, prediction container) and the Runtime Engine (Swagger, ResourceEcoCustomer, StagePrediction, PredictorModel). The bottom band is platform tools: Google Cloud AI, Microsoft Machine Learning Studio, AWS, IBM Watson, and H2O including Sparkling Water.",
  },
] as const;

export function BusinessEcosystemsGallery() {
  return <SlideGallery slides={businessEcosystems} tone="paper" />;
}

export function PredictionServerGallery() {
  return <SlideGallery slides={predictionServer} tone="paper" />;
}

export function ProductArchitectureFigure() {
  return <SlideGallery slides={architecture} tone="paper" />;
}
